<template>
<div>
    <Modal v-if="modal"/>
    <div :class="$style.container">
        <div :class="$style.header" v-html="message.header"/>

        <div :class="$style.body" v-html="message.body"/>

        <div :class="$style.footer">
            <button @click="$emit('close')">continue</button>
        </div>
    </div>    
</div>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
export default {
    name: 'SysDialog',
    components: {
        Modal
    },
    props: {
        message: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            modal: true
        }
    }
}
</script>

<style module>
.container{
    position: fixed;
    top: 40%;
    left: 50%;
    width: 300px;
    min-height: 300px;
    max-height: 100vh;
    border: 1px solid grey;
    background-color: white;
    transform: translateX(-50%) translateY(-50%);
    box-shadow: 0px 0px 50px 10px #262626;
}

.header{
    width: 100%;
    min-height: 30px;
    padding-top: 12px;
    text-align: center;
    font-weight: bold;
    border-bottom: 1px solid lightgrey;
}

.body{
    padding: 15px;
	text-align: center;
}

.footer{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 35px;
    background-color: #fafafa;
    text-align: center;
    padding-top: 12px;
}
</style>